import React, { useRef, useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";
import { bffAuthService } from "./services/BffAuthService";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Box, ToggleButton, ToggleButtonGroup, Typography, Link } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useFileStore } from "./stores/fileStore";
import { DEFAULT_LANGUAGE } from "./common/MetaSetting";
import { sendRequestToUCServer } from "./registerAPI";
import { ROUTES_LIST } from "./home/constants";
import { getStandardButtonStyles } from "./styles";


const titleContainer = document.getElementById("title")!;

export const FIntro = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isAuthenticated = bffAuthService.isAuthenticated;
  const [searchParams] = useSearchParams();
  
  console.log(t('intro.componentLoaded'));
  console.log(`${t('intro.isAuthenticated')}:`, isAuthenticated);

  useEffect(() => {
    // 根路径自动跳转到/home
    const redirectTo = searchParams.get('redirectTo') || ROUTES_LIST.dashboard;
    console.log(`${t('intro.redirectingTo')}:`, redirectTo);
    navigate(redirectTo);
  }, [navigate, searchParams]);

  const [username, setUsername] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [helperText, setHelperText] = useState("");
  const [error, setError] = useState(false);

  const { currentLanguage } = useFileStore();
  const [currentLang, setCurrentLang] = useState(DEFAULT_LANGUAGE);

  const ref = useRef<ReturnType<typeof setInterval> | null>(null);

  const triggerSyncTasks = () => {};

  useEffect(() => {
    if (username.trim() && emailAddress.trim() && password.trim() && confirmPassword.trim() && password === confirmPassword) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [username, emailAddress, password, confirmPassword]);

  useEffect(() => {
    i18n.changeLanguage("zh-CN");
  }, []);

  const handleLanguageChange = (event: React.MouseEvent<HTMLElement>, newAlignment: any) => {
    setCurrentLang(newAlignment);
    i18n.changeLanguage(newAlignment === "zhCN" ? "zh-CN" : "en-US");
  };

  const handleLoginClick = () => {
    console.log(t('intro.startingOAuthLogin'));
    window.location.href = '/login';
  };

  const handleRegisterClick = () => {
    navigate(ROUTES_LIST.register);
  };

  titleContainer.innerHTML = t("webTitle");

  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "black",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        ></Box>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              height: "50px",
            }}
          >
            <Box></Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "100px",
              }}
            >
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: 3,
              padding: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "end",
                width: "300px",
                height: "100%",
                padding: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: "end",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box>
                  <img src={process.env.PUBLIC_URL + "/logo_ccdtn.png"} style={{ width: "100%", height: "auto" }} alt={t('intro.ccdtnLogo')} />
                </Box>
                <Typography>{t('intro.welcomeToCCDTN')}</Typography>
                <Typography>{t('intro.loginOrRegisterHere')}</Typography>
                <Typography>{t('intro.accessOtherApps')}</Typography>
                <a href="https://web.wisememo.com">{t('intro.wisememoApp')}</a>
              </Box>
              <Box></Box>
            </Box>
            <Box
              sx={{
                width: "1px",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                marginLeft: 1,
                marginRight: 1,
              }}
            ></Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "300px",
                padding: 1,
              }}
            >
              <form noValidate autoComplete="off" style={{ width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "stretch",
                    width: "100%",
                    backgroundColor: "rgba(253, 253, 253, 0.9)",
                    borderRadius: 2,
                    padding: 1,
                  }}
                >
                  <Box
                    sx={{
                      paddingTop: 1,
                      paddingBottom: 1,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleLoginClick()}
                      sx={getStandardButtonStyles({ type: 'fullWidth' })}
                    >
                      {t("button.login")}
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      paddingTop: 1,
                      paddingBottom: 1,
                    }}
                  >
                    <Typography>{t('intro.or')}</Typography>
                  </Box>
                  <Box
                    sx={{
                      paddingTop: 1,
                      paddingBottom: 1,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => handleRegisterClick()}
                      sx={getStandardButtonStyles({ color: 'success', type: 'fullWidth' })}
                    >
                      {t("button.register")}
                    </Button>
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Typography>
              {t("copyRight")} | {t("verifyInfo")} | {t("securityInfo")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default FIntro;
